import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/api-response.dto';
import { AssignedRequestItemDto, PendingApprovalItemDto } from '../models/global-search.dto';

export interface GlobalSearchListParams {
  search?: string;
  ordering?: 'name' | '-updated_at' | '-created_at';
  /** Status names, case-insensitive; sent as a repeated `status` param. */
  status?: readonly string[];
  /** At most 100 server-side. */
  limit?: number;
}

/**
 * The global search's request lists, scoped to the caller across every project they can access.
 * See "Global search: assigned to me and pending my approval" in prompts/REQUESTS_API.md.
 */
@Injectable({
  providedIn: 'root',
})
export class GlobalSearchService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiHost}/api/request-tickets`;

  getAssignedToMe(params: GlobalSearchListParams = {}): Observable<ApiResponse<AssignedRequestItemDto[]>> {
    return this.http.get<ApiResponse<AssignedRequestItemDto[]>>(`${this.apiUrl}/assigned-to-me/`, {
      params: this.toHttpParams(params),
    });
  }

  getPendingMyApproval(params: GlobalSearchListParams = {}): Observable<ApiResponse<PendingApprovalItemDto[]>> {
    return this.http.get<ApiResponse<PendingApprovalItemDto[]>>(`${this.apiUrl}/pending-my-approval/`, {
      params: this.toHttpParams(params),
    });
  }

  private toHttpParams({ search, ordering, status, limit }: GlobalSearchListParams): HttpParams {
    let params = new HttpParams();
    if (search) params = params.set('search', search);
    if (ordering) params = params.set('ordering', ordering);
    for (const name of status ?? []) params = params.append('status', name);
    if (limit !== undefined) params = params.set('limit', String(limit));
    return params;
  }
}
